import React, { memo } from 'react'

interface IExpandableTextProps {
  text: string
  label?: string
  tall?: boolean
  id?: string
}

export const ExpandableText = memo<IExpandableTextProps>(({ id, label, tall, text }) => {
  const textClassName = tall ? 'ellipsis-text tall' : 'ellipsis-text'
  return (
    <div className='expandable-ellipsis pb4'>
      {label && <p className='text-secondary'>{label}</p>}
      {text && (
        <>
          <input
            id={`collapsible${id}`}
            className='ellipsis-toggle'
            type='checkbox'
            defaultChecked
          />
          <p className={textClassName}>
            {text}
            <label
              aria-label='Toggle text'
              htmlFor={`collapsible${id}`}
              className='ellipsis-toggle-label'
            />
          </p>
        </>
      )}
    </div>
  )
})

export default ExpandableText
